import { Typography, TypographyProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Link from "@rui/Link";
import Stack, { Row } from "@rui/Stack";

export const Wrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${theme.palette.shades.neutral[50]}`,
  },
}));

export const Result = styled(Row)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: theme.palette.transparent.black[2],
    "& .search_result__title": {
      color: theme.palette.shades.primary[500],
    },
  },
}));

export const MeetingTitle = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[800],
  fontWeight: 500,
  "&:hover": {
    color: theme.palette.shades.primary[500],
  },
}));

export const SubText = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  color: theme.palette.shades.neutral[400],
  fontWeight: 500,
  fontFamily: theme.typography.fontFamilySecondary,
}));

type ResultMatchTextProps = TypographyProps & { href?: string };

export const ResultMatchText = styled(
  ({ href, ...props }: ResultMatchTextProps) => (
    <Link href={href}>
      <Typography {...props} />
    </Link>
  )
)(({ theme }) => ({
  fontSize: "0.875rem",
  color: theme.palette.shades.neutral[700],
  fontFamily: theme.typography.fontFamilySecondary,
  lineHeight: 18 / 14,
  padding: "2px",
  borderRadius: "2px",
  "&:hover": {
    color: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[400],
  },
}));
